var url = window.location.origin
export const BaseUrl =
    // url === "http://gayatriagroerp.gkmarket.in" ? "http://gayatriagroerpapi.gkmarket.in"

    url === "http://garden.nmmcsmartservices.com" ? "http://gardenapi.nmmcsmartservices.com"
        : url === "http://pcmc.cdatinfotech.com" ? "http://pcmcapi.cdatinfotech.com" :
            url === "http://new.nmmcsmartservices.com" ? "http://newapi.nmmcsmartservices.com" :
                url === "https://nmmcdaksha.cdat.work" ? "https://apinmmcdaksha.cdat.work" :
                    url === "https://nmmcdaksha.in" ? "https://api.nmmcdaksha.in" :

                        // "http://pcmcapi.cdatinfotech.com"
                        "https://apinmmcdaksha.cdat.work"
                        // "http://newapi.nmmcsmartservices.com" 
// "http://newapi.nmmcsmartservices.com"
// "http://gardenapi.nmmcsmartservices.com"

// "http://newapi.nmmcsmartservices.com"




